import { DecryptAES, EncryptAES } from '../utils/services/authentication/AESService';
import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getVouchersForRedeem = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Voucher/GetVouchersForRedeem`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const submitRedemptionRequest = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Voucher/SubmitVouchersForRedeem`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getRewardRedemptionLog = async (studentId, authenticationKey) => {
    var key = localStorage.getItem('aesKey');
    var iv = localStorage.getItem('aesIV');
    studentId = EncryptAES(studentId, key, iv);
    authenticationKey = EncryptAES(authenticationKey, key, iv);

    var bodyFormData = new FormData();
    bodyFormData.set('studentId', studentId);
    bodyFormData.set('authenticationKey', authenticationKey);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Reward/RewardLog`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return DecryptAES(response.data, key, iv);
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getTransactionLogsByStudentNumber = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetTransactionLogsByStudentNumber/${Claims.getGivenName()}`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getCampaigns = async () => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Campaign/GetCampaignsForDonation`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const submitDonationRequest = async (bodyFormData) => {
    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}Campaign/DonateForCampaign`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};